"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReconciliationLooper = void 0;
const tslib_1 = require("tslib");
const p_queue_1 = tslib_1.__importDefault(require("p-queue"));
const sleep_1 = require("../methods/sleep");
class PQueueWrapper {
    constructor() {
        this._queue = new p_queue_1.default({ concurrency: 1 });
    }
    add(task) {
        return this._queue.add(task);
    }
    start() {
        this._queue.start();
    }
    async stop() {
        await this._queue.onIdle();
        this._queue.pause();
    }
}
class ReconciliationLooper {
    constructor(_name, _sleepStepMs, eventHandler, reconciler) {
        this._name = _name;
        this._sleepStepMs = _sleepStepMs;
        this.eventHandler = eventHandler;
        this.reconciler = reconciler;
        this._running = false;
        this._loopNumber = 0;
        this._looperQueue = new PQueueWrapper();
    }
    get name() {
        return this._name;
    }
    get loopNumber() {
        return this._loopNumber;
    }
    get sleepStepMs() {
        return this._sleepStepMs;
    }
    get isRunning() {
        return this._running;
    }
    async start() {
        if (this._running) {
            throw new Error(`ReconciliationLooper ${this._name} is already in running state!`);
        }
        this._looperQueue.start();
        await this.eventHandler.onStart();
        this._running = true;
        this._mainLoop = this.mainLoop()
            .catch(async (err) => await this.eventHandler.onError(err))
            .finally(async () => {
            await this.eventHandler.onFinished();
            this._mainLoop = undefined;
            this._running = false;
        });
    }
    async stop() {
        await this.eventHandler.onStop();
        await this._looperQueue.stop();
        this._loopNumber = -1;
        this._running = false;
    }
    async waitUntilStopped() {
        if (!this._mainLoop) {
            return;
        }
        await this._mainLoop;
    }
    async mainLoop() {
        this._loopNumber = 0;
        while (this._running) {
            // get current state
            const currentState = await this.reconciler.fetchCurrentState();
            // get desired state
            const desiredState = await this.reconciler.fetchDesiredState();
            // compare states and create delta
            const delta = await this.reconciler.calculateDelta(currentState, desiredState);
            // apply delta
            await this.reconciler.applyDelta(delta, this._looperQueue);
            this._loopNumber++;
            await this.eventHandler.onSuccess(this._loopNumber);
            await sleep_1.sleep(this._sleepStepMs);
        }
    }
}
exports.ReconciliationLooper = ReconciliationLooper;
//# sourceMappingURL=reconciliation-looper.js.map